<template>
  <div class="page font-size-1-2 align-items-center" style="min-height: 100vh;">
    <div class="container-fluid h-100 align-items-center">
      <b-row class="h-100 justify-content-center align-items-center pt-3">
        <b-col class="col-12 col-sm-4 col-md-4 col-lg-3">
          <b-card
            overlay
            :img-src="thaimap"
            class="bg-transparent border-0"
          >
            <img class="map" :src="east_map" v-if="east.length!=0">
            <img class="map" :src="northeast_map" v-if="northeast.length!=0">
            <img class="map" :src="west_map" v-if="west.length!=0">
            <img class="map" :src="central_map" v-if="central.length!=0">
            <img class="map" :src="south_map" v-if="south.length!=0">
            <img class="map" :src="north_map" v-if="north.length!=0">
            <img class="map" :src="null_map">
          </b-card>
          <p v-if="central.length!=0" class="text-light"><span class="rounded" style="background-color: #48b1e5">&nbsp;&nbsp;&nbsp;&nbsp;</span> ภาคกลาง : {{central.length}} ฟาร์ม</p>
          <p v-if="north.length!=0" class="text-light"><span class="rounded" style="background-color: #e089d8">&nbsp;&nbsp;&nbsp;&nbsp;</span> ภาคเหนือ : {{north.length}}</p>
          <p v-if="northeast.length!=0" class="text-light"><span class="rounded" style="background-color: #2bdaed">&nbsp;&nbsp;&nbsp;&nbsp;</span> ภาคตะวันออกเฉียงเหนือ : {{northeast.length}} ฟาร์ม</p>
          <p v-if="east.length!=0" class="text-light"><span class="rounded" style="background-color: #27d6ac">&nbsp;&nbsp;&nbsp;&nbsp;</span> ภาคตะวันออก : {{east.length}} ฟาร์ม</p>
          <p v-if="west.length!=0" class="text-light"><span class="rounded" style="background-color: #6969ed">&nbsp;&nbsp;&nbsp;&nbsp;</span> ภาคตะวันตก : {{west.length}} ฟาร์ม</p>
          <p v-if="south.length!=0" class="text-light"><span class="rounded" style="background-color: #ac76f4">&nbsp;&nbsp;&nbsp;&nbsp;</span> ภาคใต้ : {{south.length}} ฟาร์ม</p>
        </b-col>
        <b-col class="col-12 col-sm-8 col-md-8 col-lg-6">
          <b-row class="p-1">
            <b-col class="col-12">
              <h5 class="m-0 py-1 text-light">Admin : วนัส ท้วมเจริญ</h5>
            </b-col>
          </b-row>
          <b-row class="p-1">
            <b-col class="col-12">
              <b-row>
                <b-col class="col-12" v-if="central.length!=0">
                  <h5 class="m-0 py-1" style="color: #48b1e5">ภาคกลาง</h5>
                  <b-row>
                    <b-col class="col-12 col-sm-6 col-md-6 col-lg-4" v-for="(val, index) in central" :value="val" :key="index">
                      <b-row class="p-1">
                        <b-col class="col-12 rounded shadow border border-light text-light">
                          <b-row class="mt-2">
                            <b-col class="col px-1">
                              {{ val.name_th }}
                            </b-col>
                            <b-col class="col-auto text-right px-1">
                              <font-awesome-icon :icon="['fas', 'bell']" class="mx-1" style="color: #69F0AE" /><sup><span class="badge text-dark" style="background-color: #69F0AE">{{ val.temperature }}</span></sup>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col class="col-6 text-center px-1">
                              <span class="badge" style="background-color: #4CAF50; margin-right: 3px"><font-awesome-icon :icon="['fas', 'home']" class="text-light" /> 99</span>
                              <span class="badge" style="background-color: #F44336"><font-awesome-icon :icon="['fas', 'home']" class="text-light" /> 99</span>
                            </b-col>
                            <b-col class="col-6 text-center px-1">
                              <span class="badge" style="background-color: #29B6F6; margin-right: 3px"><font-awesome-icon :icon="['fas', 'wifi']" class="text-light" /> 99</span>
                              <span class="badge" style="background-color: #9E9E9E"><font-awesome-icon :icon="['fas', 'wifi']" class="text-light" /> 99</span>
                            </b-col>
                          </b-row>
                          <b-row class="p-1">
                            <b-col class="col-12 text-center rounded" :style="{backgroundImage}">
                              <b-row class="p-1 align-self-center">
                                <b-col class="col-12 p-1 text-light text-shadow align-self-center justify-content-center">
                                  <b-img :src="iconImage" class="rounded-circle bg-icon" style="width: 30px"></b-img>
                                  <span class="ml-1 font-size-0-9">{{nameLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationTemp font-weight-normal w-100">{{temperatureLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationHum font-weight-normal w-100">{{humidityLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationWind font-weight-normal w-100">{{windLocation}}</span>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col class="col-12 text-center px-1">
                              <b-button size="sm" variant="link">ไปยังหน้าแดชบอร์ด <font-awesome-icon :icon="['fas', 'share-square']" /></b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="col-12" v-if="north.length!=0">
                  <h5 class="m-0 py-1" style="color: #e089d8">ภาคเหนือ</h5>
                  <b-row>
                    <b-col class="col-12 col-sm-6 col-md-6 col-lg-4" v-for="(val, index) in north" :value="val" :key="index">
                      <b-row class="p-1">
                        <b-col class="col-12 rounded shadow border border-light text-light">
                          <b-row class="mt-2">
                            <b-col class="col px-1">
                              {{ val.name_th }}
                            </b-col>
                            <b-col class="col-auto text-right px-1">
                              <font-awesome-icon :icon="['fas', 'bell']" class="mx-1" style="color: #69F0AE" /><sup><span class="badge text-dark" style="background-color: #69F0AE">{{ val.temperature }}</span></sup>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col class="col-6 text-center px-1">
                              <span class="badge" style="background-color: #4CAF50; margin-right: 3px"><font-awesome-icon :icon="['fas', 'home']" class="text-light" /> 99</span>
                              <span class="badge" style="background-color: #F44336"><font-awesome-icon :icon="['fas', 'home']" class="text-light" /> 99</span>
                            </b-col>
                            <b-col class="col-6 text-center px-1">
                              <span class="badge" style="background-color: #29B6F6; margin-right: 3px"><font-awesome-icon :icon="['fas', 'wifi']" class="text-light" /> 99</span>
                              <span class="badge" style="background-color: #9E9E9E"><font-awesome-icon :icon="['fas', 'wifi']" class="text-light" /> 99</span>
                            </b-col>
                          </b-row>
                          <b-row class="p-1">
                            <b-col class="col-12 text-center rounded" :style="{backgroundImage}">
                              <b-row class="p-1 align-self-center">
                                <b-col class="col-12 p-1 text-light text-shadow align-self-center justify-content-center">
                                  <b-img :src="iconImage" class="rounded-circle bg-icon" style="width: 30px"></b-img>
                                  <span class="ml-1 font-size-0-9">{{nameLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationTemp font-weight-normal w-100">{{temperatureLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationHum font-weight-normal w-100">{{humidityLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationWind font-weight-normal w-100">{{windLocation}}</span>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col class="col-12 text-center px-1">
                              <b-button size="sm" variant="link">ไปยังหน้าแดชบอร์ด <font-awesome-icon :icon="['fas', 'share-square']" /></b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="col-12" v-if="northeast.length!=0">
                  <h5 class="m-0 py-1" style="color: #2bdaed">ภาคตะวันออกเฉียงเหนือ</h5>
                  <b-row>
                    <b-col class="col-12 col-sm-6 col-md-6 col-lg-4" v-for="(val, index) in northeast" :value="val" :key="index">
                      <b-row class="p-1">
                        <b-col class="col-12 rounded shadow border border-light text-light">
                          <b-row class="mt-2">
                            <b-col class="col px-1">
                              {{ val.name_th }}
                            </b-col>
                            <b-col class="col-auto text-right px-1">
                              <font-awesome-icon :icon="['fas', 'bell']" class="mx-1" style="color: #69F0AE" /><sup><span class="badge text-dark" style="background-color: #69F0AE">{{ val.temperature }}</span></sup>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col class="col-6 text-center px-1">
                              <span class="badge" style="background-color: #4CAF50; margin-right: 3px"><font-awesome-icon :icon="['fas', 'home']" class="text-light" /> 99</span>
                              <span class="badge" style="background-color: #F44336"><font-awesome-icon :icon="['fas', 'home']" class="text-light" /> 99</span>
                            </b-col>
                            <b-col class="col-6 text-center px-1">
                              <span class="badge" style="background-color: #29B6F6; margin-right: 3px"><font-awesome-icon :icon="['fas', 'wifi']" class="text-light" /> 99</span>
                              <span class="badge" style="background-color: #9E9E9E"><font-awesome-icon :icon="['fas', 'wifi']" class="text-light" /> 99</span>
                            </b-col>
                          </b-row>
                          <b-row class="p-1">
                            <b-col class="col-12 text-center rounded" :style="{backgroundImage}">
                              <b-row class="p-1 align-self-center">
                                <b-col class="col-12 p-1 text-light text-shadow align-self-center justify-content-center">
                                  <b-img :src="iconImage" class="rounded-circle bg-icon" style="width: 30px"></b-img>
                                  <span class="ml-1 font-size-0-9">{{nameLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationTemp font-weight-normal w-100">{{temperatureLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationHum font-weight-normal w-100">{{humidityLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationWind font-weight-normal w-100">{{windLocation}}</span>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col class="col-12 text-center px-1">
                              <b-button size="sm" variant="link">ไปยังหน้าแดชบอร์ด <font-awesome-icon :icon="['fas', 'share-square']" /></b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="col-12" v-if="east.length!=0">
                  <h5 class="m-0 py-1" style="color: #27d6ac">ภาคตะวันออก</h5>
                  <b-row>
                    <b-col class="col-12 col-sm-6 col-md-6 col-lg-4" v-for="(val, index) in east" :value="val" :key="index">
                      <b-row class="p-1">
                        <b-col class="col-12 rounded shadow border border-light text-light">
                          <b-row class="mt-2">
                            <b-col class="col px-1">
                              {{ val.name_th }}
                            </b-col>
                            <b-col class="col-auto text-right px-1">
                              <font-awesome-icon :icon="['fas', 'bell']" class="mx-1" style="color: #69F0AE" /><sup><span class="badge text-dark" style="background-color: #69F0AE">{{ val.temperature }}</span></sup>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col class="col-6 text-center px-1">
                              <span class="badge" style="background-color: #4CAF50; margin-right: 3px"><font-awesome-icon :icon="['fas', 'home']" class="text-light" /> 99</span>
                              <span class="badge" style="background-color: #F44336"><font-awesome-icon :icon="['fas', 'home']" class="text-light" /> 99</span>
                            </b-col>
                            <b-col class="col-6 text-center px-1">
                              <span class="badge" style="background-color: #29B6F6; margin-right: 3px"><font-awesome-icon :icon="['fas', 'wifi']" class="text-light" /> 99</span>
                              <span class="badge" style="background-color: #9E9E9E"><font-awesome-icon :icon="['fas', 'wifi']" class="text-light" /> 99</span>
                            </b-col>
                          </b-row>
                          <b-row class="p-1">
                            <b-col class="col-12 text-center rounded" :style="{backgroundImage}">
                              <b-row class="p-1 align-self-center">
                                <b-col class="col-12 p-1 text-light text-shadow align-self-center justify-content-center">
                                  <b-img :src="iconImage" class="rounded-circle bg-icon" style="width: 30px"></b-img>
                                  <span class="ml-1 font-size-0-9">{{nameLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationTemp font-weight-normal w-100">{{temperatureLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationHum font-weight-normal w-100">{{humidityLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationWind font-weight-normal w-100">{{windLocation}}</span>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col class="col-12 text-center px-1">
                              <b-button size="sm" variant="link">ไปยังหน้าแดชบอร์ด <font-awesome-icon :icon="['fas', 'share-square']" /></b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="col-12" v-if="west.length!=0">
                  <h5 class="m-0 py-1" style="color: #6969ed">ภาคตะวันตก</h5>
                  <b-row>
                    <b-col class="col-12 col-sm-6 col-md-6 col-lg-4" v-for="(val, index) in west" :value="val" :key="index">
                      <b-row class="p-1">
                        <b-col class="col-12 rounded shadow border border-light text-light">
                          <b-row class="mt-2">
                            <b-col class="col px-1">
                              {{ val.name_th }}
                            </b-col>
                            <b-col class="col-auto text-right px-1">
                              <font-awesome-icon :icon="['fas', 'bell']" class="mx-1" style="color: #69F0AE" /><sup><span class="badge text-dark" style="background-color: #69F0AE">{{ val.temperature }}</span></sup>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col class="col-6 text-center px-1">
                              <span class="badge" style="background-color: #4CAF50; margin-right: 3px"><font-awesome-icon :icon="['fas', 'home']" class="text-light" /> 99</span>
                              <span class="badge" style="background-color: #F44336"><font-awesome-icon :icon="['fas', 'home']" class="text-light" /> 99</span>
                            </b-col>
                            <b-col class="col-6 text-center px-1">
                              <span class="badge" style="background-color: #29B6F6; margin-right: 3px"><font-awesome-icon :icon="['fas', 'wifi']" class="text-light" /> 99</span>
                              <span class="badge" style="background-color: #9E9E9E"><font-awesome-icon :icon="['fas', 'wifi']" class="text-light" /> 99</span>
                            </b-col>
                          </b-row>
                          <b-row class="p-1">
                            <b-col class="col-12 text-center rounded" :style="{backgroundImage}">
                              <b-row class="p-1 align-self-center">
                                <b-col class="col-12 p-1 text-light text-shadow align-self-center justify-content-center">
                                  <b-img :src="iconImage" class="rounded-circle bg-icon" style="width: 30px"></b-img>
                                  <span class="ml-1 font-size-0-9">{{nameLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationTemp font-weight-normal w-100">{{temperatureLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationHum font-weight-normal w-100">{{humidityLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationWind font-weight-normal w-100">{{windLocation}}</span>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col class="col-12 text-center px-1">
                              <b-button size="sm" variant="link">ไปยังหน้าแดชบอร์ด <font-awesome-icon :icon="['fas', 'share-square']" /></b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="col-12" v-if="south.length!=0">
                  <h5 class="m-0 py-1" style="color: #ac76f4">ภาคใต้</h5>
                  <b-row>
                    <b-col class="col-12 col-sm-6 col-md-6 col-lg-4" v-for="(val, index) in south" :value="val" :key="index">
                      <b-row class="p-1">
                        <b-col class="col-12 rounded shadow border border-light text-light">
                          <b-row class="mt-2">
                            <b-col class="col px-1">
                              {{ val.name_th }}
                            </b-col>
                            <b-col class="col-auto text-right px-1">
                              <font-awesome-icon :icon="['fas', 'bell']" class="mx-1" style="color: #69F0AE" /><sup><span class="badge text-dark" style="background-color: #69F0AE">{{ val.temperature }}</span></sup>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col class="col-6 text-center px-1">
                              <span class="badge" style="background-color: #4CAF50; margin-right: 3px"><font-awesome-icon :icon="['fas', 'home']" class="text-light" /> 99</span>
                              <span class="badge" style="background-color: #F44336"><font-awesome-icon :icon="['fas', 'home']" class="text-light" /> 99</span>
                            </b-col>
                            <b-col class="col-6 text-center px-1">
                              <span class="badge" style="background-color: #29B6F6; margin-right: 3px"><font-awesome-icon :icon="['fas', 'wifi']" class="text-light" /> 99</span>
                              <span class="badge" style="background-color: #9E9E9E"><font-awesome-icon :icon="['fas', 'wifi']" class="text-light" /> 99</span>
                            </b-col>
                          </b-row>
                          <b-row class="p-1">
                            <b-col class="col-12 text-center rounded" :style="{backgroundImage}">
                              <b-row class="p-1 align-self-center">
                                <b-col class="col-12 p-1 text-light text-shadow align-self-center justify-content-center">
                                  <b-img :src="iconImage" class="rounded-circle bg-icon" style="width: 30px"></b-img>
                                  <span class="ml-1 font-size-0-9">{{nameLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationTemp font-weight-normal w-100">{{temperatureLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationHum font-weight-normal w-100">{{humidityLocation}}</span>
                                </b-col>
                                <b-col class="col-4 align-self-center px-1">
                                  <span class="badge bg-locationWind font-weight-normal w-100">{{windLocation}}</span>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col class="col-12 text-center px-1">
                              <b-button size="sm" variant="link">ไปยังหน้าแดชบอร์ด <font-awesome-icon :icon="['fas', 'share-square']" /></b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="p-1">
            <b-col class="col-12 text-right">
              <b-button variant="danger">ออกจากระบบ</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <Footer />
    </div>
  </div>
</template>

<script>
import axios from 'axios'

import Footer from "@/components/Footer.vue";
import thaimap from "../assets/img/thai-map.png";
import east_map from "../assets/img/east-map.png";
import northeast_map from "../assets/img/northeast-map.png";
import north_map from "../assets/img/north-map.png";
import west_map from "../assets/img/west-map.png";
import central_map from "../assets/img/central-map.png";
import south_map from "../assets/img/south-map.png";
import null_map from "../assets/img/null-map.png";

import broken_clouds from '../assets/img/broken clouds.jpg'
import clear_sky from '../assets/img/clear sky.jpg'
import clouds from '../assets/img/clouds.jpg'
import few_clouds from '../assets/img/few clouds.jpg'
import light_rain from '../assets/img/light rain.jpg'
import moderate_rain from '../assets/img/moderate rain.jpg'
import overcast_clouds from '../assets/img/overcast clouds.jpg'
import rain from '../assets/img/rain.jpg'
import scattered_clouds from '../assets/img/scattered clouds.jpg'
import shower_rain from '../assets/img/shower rain.jpg'
import thunderstorm_with_light_rain from '../assets/img/thunderstorm with light rain.jpg'
import thunderstorm from '../assets/img/thunderstorm.jpg'
import weather_cloud from '../assets/img/weather cloud.jpg'

import icon_broken_clouds from '../assets/icon/broken clouds.png'
import icon_clear_sky from '../assets/icon/clear sky.png'
import icon_clouds from '../assets/icon/clouds.png'
import icon_few_clouds from '../assets/icon/few clouds.png'
import icon_light_rain from '../assets/icon/light rain.png'
import icon_moderate_rain from '../assets/icon/moderate rain.png'
import icon_overcast_clouds from '../assets/icon/overcast clouds.png'
import icon_rain from '../assets/icon/rain.png'
import icon_scattered_clouds from '../assets/icon/scattered clouds.png'
import icon_shower_rain from '../assets/icon/shower rain.png'
import icon_thunderstorm_with_light_rain from '../assets/icon/thunderstorm with light rain.png'
import icon_thunderstorm from '../assets/icon/thunderstorm.png'
import icon_weather_cloud from '../assets/icon/clouds.png'

export default {
  name: "company",
  components: {
    Footer
  },
  data() {
    return {
      allFarm: [],
      thaimap,
      east_map,
      northeast_map,
      north_map,
      west_map,
      central_map,
      south_map,
      null_map,
      east: [],
      northeast: [],
      north: [],
      west: [],
      central: [],
      south: [],
      farms : [
        {
          "farm_id": 3,
          "farm_token": "2110001",
          "name_th": "ฟาร์มหนองคาย",
          "name_en": "nong_khai",
          "province": "หนองคาย",
          "region": "ภาคตะวันออกเฉียงเหนือ",
          "temperature": 25,
          "humidity": 60,
          "wind": 1.3
        },
        {
          "farm_id": 4,
          "farm_token": "2110002",
          "name_th": "ฟาร์มขอนแก่น",
          "name_en": "khon_kaen",
          "province": "ขอนแก่น",
          "region": "ภาคตะวันออกเฉียงเหนือ",
          "temperature": 25,
          "humidity": 60,
          "wind": 1.3
        },
        {
          "farm_id": 5,
          "farm_token": "2211001",
          "name_th": "ฟาร์มส่งเสริมชุมแพ",
          "name_en": "chum_phae_health_center",
          "province": "ขอนแก่น",
          "region": "ภาคตะวันออกเฉียงเหนือ",
          "temperature": 25,
          "humidity": 60,
          "wind": 1.3
        },
        {
          "farm_id": 6,
          "farm_token": "2211002",
          "name_th": "ฟาร์มส่งเสริมนภัสวรรณ",
          "name_en": "napasawan",
          "province": "เพชรบูรณ์",
          "region": "ภาคกลาง",
          "temperature": 25,
          "humidity": 60,
          "wind": 1.3
        },
        {
          "farm_id": 7,
          "farm_token": "2211003",
          "name_th": "ฟาร์มส่งเสริมเนตรบุญ",
          "name_en": "netboon",
          "province": "กาญจนบุรี",
          "region": "ภาคกลาง",
          "temperature": 25,
          "humidity": 60,
          "wind": 1.3
        },
        {
          "farm_id": 8,
          "farm_token": "2211004",
          "name_th": "ฟาร์มเขาพริก",
          "name_en": "khao_prik",
          "province": "นครราชสีมา",
          "region": "ภาคตะวันออกเฉียงเหนือ",
          "temperature": 25,
          "humidity": 60,
          "wind": 1.3
        },
        {
          "farm_id": 9,
          "farm_token": "2110003",
          "name_th": "ฟาร์มโคกปี่ฆ้อง",
          "name_en": "khok_pi_khong",
          "province": "สระแก้ว",
          "region": "ภาคตะวันออก",
          "temperature": 25,
          "humidity": 60,
          "wind": 1.3
        },
        {
          "farm_id": 10,
          "farm_token": "2111001",
          "name_th": "ฟาร์มซับใหญ่",
          "name_en": "sub_yai",
          "province": "ชัยภูมิ",
          "region": "ภาคตะวันออกเฉียงเหนือ",
          "temperature": 25,
          "humidity": 60,
          "wind": 1.3
        },
        {
          "farm_id": 11,
          "farm_token": "2120001",
          "name_th": "ฟาร์มวังม่วง",
          "name_en": "wang_muang",
          "province": "สระบุรี",
          "region": "ภาคกลาง",
          "temperature": 25,
          "humidity": 60,
          "wind": 1.3
        }
      ],
      backgroundImage: '',
      iconImage: null,
      broken_clouds,
      clear_sky,
      clouds,
      few_clouds,
      light_rain,
      moderate_rain,
      overcast_clouds,
      rain,
      scattered_clouds,
      shower_rain,
      thunderstorm_with_light_rain,
      thunderstorm,
      weather_cloud,
      icon_broken_clouds,
      icon_clear_sky,
      icon_clouds,
      icon_few_clouds,
      icon_light_rain,
      icon_moderate_rain,
      icon_overcast_clouds,
      icon_rain,
      icon_scattered_clouds,
      icon_shower_rain,
      icon_thunderstorm_with_light_rain,
      icon_thunderstorm,
      icon_weather_cloud,
      nameLocation: '',
      temperatureLocation: '',
      humidityLocation: '',
      windLocation: '',
    }
  },
  mounted() {
    // if(this.$store.getters.loggedIn == true) {
    //   localStorage.removeItem('farm_id')
    //   this.viewFarm()
    // }
    // else {
    //   this.$nextTick(() => {
    //     this.$router.push({
    //       name: "login"
    //     });
    //   });
    // }
    this.east = []
    this.northeast = []
    this.north = []
    this.west = []
    this.central = []
    this.south = []
    for(let i in this.farms) {
      if(this.farms[i].region == "ภาคตะวันออก") {
        this.east.push(this.farms[i])
      }
      else if(this.farms[i].region == "ภาคตะวันออกเฉียงเหนือ") {
        this.northeast.push(this.farms[i])
      }
      else if(this.farms[i].region == "ภาคเหนือ") {
        this.north.push(this.farms[i])
      }
      else if(this.farms[i].region == "ภาคตะวันตก") {
        this.west.push(this.farms[i])
      }
      else if(this.farms[i].region == "ภาคกลาง") {
        this.central.push(this.farms[i])
      }
      else if(this.farms[i].region == "ภาคใต้") {
        this.south.push(this.farms[i])
      }
    }

    this.getLocalAPI()
  },
  methods: {
    selectFarm(url) {
      console.log(url)
      window.location = url
    },
    getLocalAPI() {
      axios.get('https://api.openweathermap.org/data/2.5/weather?q=Mancha%20Khiri,TH&appid=d32276ec9bee1718f70705f8a49262a6')
      .then(response => {
        if(response.data.weather[0].description.toLowerCase() == 'broken clouds') {
          this.backgroundImage = `url('` + this.broken_clouds + `')`
          this.iconImage = this.icon_broken_clouds
        }
        else if(response.data.weather[0].description.toLowerCase() == 'clear sky') {
          this.backgroundImage = `url('` + this.clear_sky + `')`
          this.iconImage = this.icon_clear_sky
        }
        else if(response.data.weather[0].description.toLowerCase() == 'clouds') {
          this.backgroundImage = `url('` + this.clouds + `')`
          this.iconImage = this.icon_clouds
        }
        else if(response.data.weather[0].description.toLowerCase() == 'scattered clouds') {
          this.backgroundImage = `url('` + this.scattered_clouds + `')`
          this.iconImage = this.icon_scattered_clouds
        }
        else if(response.data.weather[0].description.toLowerCase() == 'few clouds') {
          this.backgroundImage = `url('` + this.few_clouds + `')`
          this.iconImage = this.icon_few_clouds
        }
        else if(response.data.weather[0].description.toLowerCase() == 'light rain') {
          this.backgroundImage = `url('` + this.light_rain + `')`
          this.iconImage = this.icon_light_rain
        }
        else if(response.data.weather[0].description.toLowerCase() == 'moderate rain') {
          this.backgroundImage = `url('` + this.moderate_rain + `')`
          this.iconImage = this.icon_moderate_rain
        }
        else if(response.data.weather[0].description.toLowerCase() == 'overcast clouds') {
          this.backgroundImage = `url('` + this.overcast_clouds + `')`
          this.iconImage = this.icon_overcast_clouds
        }
        else if(response.data.weather[0].description.toLowerCase() == 'rain') {
          this.backgroundImage = `url('` + this.rain + `')`
          this.iconImage = this.icon_rain
        }
        else if(response.data.weather[0].description.toLowerCase() == 'thunderstorm with light rain') {
          this.backgroundImage = `url('` + this.thunderstorm_with_light_rain + `')`
          this.iconImage = this.icon_thunderstorm_with_light_rain
        }
        else if(response.data.weather[0].description.toLowerCase() == 'thunderstorm') {
          this.backgroundImage = `url('` + this.thunderstorm + `')`
          this.iconImage = this.icon_thunderstorm
        }
        else if(response.data.weather[0].description.toLowerCase() == 'weather cloud') {
          this.backgroundImage = `url('` + this.weather_cloud + `')`
          this.iconImage = this.icon_weather_cloud
        }

        this.nameLocation = response.data.name.toUpperCase()
        this.temperatureLocation = (response.data.main.temp-273.15).toFixed(1) + " °C"
        this.humidityLocation = (response.data.main.humidity).toFixed(1) + " %"
        this.windLocation = (response.data.wind.speed).toFixed(1) + " m/s"
      })
      .catch(error => console.log(error))
    }
  }
};
</script>

<style scoped>
  @import "../assets/css/Page.css";
  @import "../assets/css/Font.css";

  .map {
    position: absolute;
    left: 0%;
    top: 0%;
    width: 100%;
  }
  .page {
    height: auto;
    min-height: 100%;
    background-color: #030730 !important;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
  }
  .bg-icon{
    text-shadow: 2px 2px #927944;
    background: linear-gradient(-45deg, #e6890f 0%, #f0dc29 100%);
    color: #ffffff;
  }
  .bg-locationTemp{
    background: linear-gradient(-45deg, #ff8248 0%, #ffb049 100%);
  }
  .bg-locationHum{
    background: linear-gradient(-45deg, #4897ff 0%, #49e4ff 100%);
  }
  .bg-locationWind{
    background: linear-gradient(-45deg, #03a31e 0%, #98ff54 100%);
  }

  .btn:disabled, input:disabled, select:disabled {
    cursor: not-allowed;
  }
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px 555555; 
    border-radius: 2px;
  }
  ::-webkit-scrollbar-thumb {
    background: #00FFFF; 
    border-radius: 2px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #00FFFF; 
  }
</style>
